"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const request_1 = require("../requests/request");
class API {
    static getUsageReportDatasource(month_year) {
        let apiRequest = new request_1.AuthenticatedRequest('/admin/usage-reporting/datasource', request_1.HTTPMethod.GET, request_1.APIVersion.v1_2, { month_year });
        return apiRequest.send().then((response) => {
            return response.data;
        });
    }
    static generateReport(month_year, index) {
        let apiRequest = new request_1.AuthenticatedRequest('/admin/usage-reporting/' + month_year + '/generate', request_1.HTTPMethod.POST, request_1.APIVersion.v1_2, undefined, { index });
        return apiRequest.send().then((response) => {
            return response.data;
        });
    }
    static getFinancialReportDatasource(start_date, end_date) {
        let apiRequest = new request_1.AuthenticatedRequest('/financial-datasource', request_1.HTTPMethod.GET, request_1.APIVersion.adminV1, { start_date: start_date.toJSON(), end_date: end_date.toJSON() });
        return apiRequest.send().then((response) => {
            return response.data;
        });
    }
    static generateFinancialReport({ start_date, end_date, no, premium, standard }) {
        let apiRequest = new request_1.AuthenticatedRequest('/financial-report', request_1.HTTPMethod.POST, request_1.APIVersion.adminV1, { start_date: start_date.toJSON(), end_date: end_date.toJSON(), no }, { standard, premium });
        return apiRequest.send().then((response) => {
            return response.data;
        });
    }
    static downloadFile(file) {
        return `${request_1.Session.getAPIURL()}/${request_1.APIVersion.adminV1}/report-file?path=${file}`;
    }
}
exports.API = API;



//////////////////
// WEBPACK FOOTER
// ./node_modules/bpm-client-api/lib/endpoints/report.js
// module id = 966
// module chunks = 0